import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

const navItems = [
    { to: "/settings/general",        label: "General" },
    { to: "/settings/notifications",  label: "Notifications" },
    { to: "/settings/mail-client",    label: "Connect an app" },
    { to: "/settings/identities",     label: "Identities & signatures" },
    { to: "/settings/labels",         label: "Labels" },
    { to: "/settings/filters",        label: "Filters & rules" },
    { to: "/settings/auto-responders", label: "Auto-responders" },
    { to: "/settings/vacation",       label: "Out of Office" },
    { to: "/settings/templates",      label: "Templates" },
    { to: "/settings/shortcuts",      label: "Keyboard shortcuts" },
];

export function SettingsPage() {
    const location = useLocation();

    return (
        <div className="flex min-h-0 flex-1">
            <aside className="hidden w-56 shrink-0 flex-col border-r bg-muted/30 p-3 md:flex">
                <h1 className="mb-3 px-2 text-sm font-semibold uppercase tracking-wider text-muted-foreground">
                    Settings
                </h1>
                <nav aria-label="Settings sections" className="flex flex-col gap-0.5">
                    {navItems.map((item) => {
                        const active = location.pathname.startsWith(item.to);
                        return (
                            <Link
                                key={item.to}
                                to={item.to}
                                className={cn(
                                    "rounded-md px-3 py-1.5 text-sm",
                                    active
                                        ? "bg-primary/10 text-primary"
                                        : "text-foreground hover:bg-accent hover:text-accent-foreground"
                                )}
                            >
                                {item.label}
                            </Link>
                        );
                    })}
                </nav>
            </aside>
            <section className="min-h-0 flex-1 overflow-auto p-6">
                <Outlet />
            </section>
        </div>
    );
}
